<template>
  <div class="product-family">
    <div class="title">{{ $t('home.productList') }}</div>
    <div class="list-wrapper">
      <div class="list scroll-bar-y">
        <div class="item" v-for="item in productList" :key="item.productName">
          <div class="icon">
            <img :src="item.icon" width="36" />
          </div>
          <div class="info">
            <div class="name">
              {{ item.productName }}
              <span :class="item.open ? 'open' : ''">
                ({{ item.open ? $t('home.opened') : $t('home.notOpened') }})
              </span>
            </div>
            <div class="desc">{{ item.desc }}</div>
          </div>
          <div class="hover-wrapper">
            <span class="help-link" @click="openHelpLink(item)">{{ $t('home.learnMore') }}</span>
            <span
              class="open-btn"
              :class="item.open ? 'open' : ''"
              @click="open(item.open)"
            >
              {{ $t('home.openNow') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { getValByPath } from "@/utils";
import Icon_Cc from "@/assets/images/product/icon_sy_hujiao@2x.png";
import Icon_Chat from "@/assets/images/product/icon_sy_zaixian@2x.png";
import Icon_Video from "@/assets/images/product/icon_sy_video@2x.png";
import Icon_Client from "@/assets/images/product/icon_sy_kehu@2x.png";
import Icon_Ticket from "@/assets/images/product/icon_sy_gongdan@2x.png";
import Icon_Sms from "@/assets/images/product/icon_sy_duanxin@2x.png";
import Icon_FlashSms from "@/assets/images/product/icon_sy_shanxin@2x.png";
import Icon_Yulanshi from "@/assets/images/product/icon_sy_yulanshi@2x.png";
import Icon_Yuceshi from "@/assets/images/product/icon_sy_yuceshi@2x.png";
import Icon_AutoCall from "@/assets/images/product/icon_sy_zidong@2x.png";
import Icon_RobotCall from "@/assets/images/product/icon_sy_jiqirenwaihu@2x.png";
import Icon_TextRobot from "@/assets/images/product/icon_sy_wenbenjiqiren@2x.png";
import Icon_VoiceRobot from "@/assets/images/product/icon_sy_yuyinjiqiren@2x.png";
import Icon_Sca from "@/assets/images/product/icon_sy_zhijian@2x.png";

export default {
  name: "product-family",
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this._Bus.$on("updateUserInfo", () => {
      this.initApps();
    });

    if (JSON.stringify(this.userInfo) != "{}") {
      this.initApps();
    }
  },
  data() {
    return {
      productList: [
        {
          productName: this.$t('home.callCenterProduct'),
          open: false,
          icon: Icon_Cc,
          path: ["cc", "cc"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/pq7N1kjGYznWy4mL6vG58O43vrPX95oA",
          desc: this.$t('home.callCenterDesc'),
        },
        {
          productName: this.$t('home.onlineServiceProduct'),
          open: false,
          icon: Icon_Chat,
          path: ["chat"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/6wPdlBDrQk4JYLyxx5YQVXKx72oEGeL5",
          desc: this.$t('home.onlineServiceDesc'),
        },
        {
          productName: this.$t('home.videoServiceProduct'),
          open: false,
          icon: Icon_Video,
          path: ["video"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/7NkDwLng8ZM02250HblRkR06JKMEvZBY",
          desc: this.$t('home.videoServiceDesc'),
        },
        {
          productName: this.$t('home.clientManage'),
          icon: Icon_Client,
          open: false,
          path: ["client", "crm"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/qXomz1wAyjKVXODaKq9kW3Y9pRBx5OrE",
          desc: this.$t('home.clientManageDesc'),
        },
        {
          productName: this.$t('home.ticketSystem'),
          icon: Icon_Ticket,
          open: false,
          path: ["ticket"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/em7AML0b9lBV2XZym5K38nNyqOD6vwro",
          desc: this.$t('home.ticketSystemDesc'),
        },
        {
          productName: this.$t('home.smsProduct'),
          icon: Icon_Sms,
          open: false,
          path: ["sms", "sms"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/QjXmLRyz4G5VGRzdAXGzWZpaD19v6NK2",
          desc: this.$t('home.smsProductDesc'),
        },
        {
          productName: this.$t('home.flashSmsProduct'),
          icon: Icon_FlashSms,
          open: false,
          path: ["sms", "flashsms"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/qXomz1wAyjKVXAeddw6lJ3Y9pRBx5OrE",
          desc: this.$t('home.flashSmsDesc'),
        },
        {
          productName: this.$t('home.previewCallProduct'),
          icon: Icon_Yulanshi,
          open: false,
          path: ["outbound", "previewCall"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/3KLw95QMzkb8gNrm53O1JAjrymPeEN2q",
          desc: this.$t('home.previewCallDesc'),
        },
        {
          productName: this.$t('home.predictiveCallProduct'),
          icon: Icon_Yuceshi,
          open: false,
          path: ["outbound", "predictiveCall"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/B6L5QAmawMPJMA4oDLK7Jq1z09lnK3kb",
          desc: this.$t('home.predictiveCallDesc'),
        },
        {
          productName: this.$t('home.autoCallProduct'),
          icon: Icon_AutoCall,
          open: false,
          path: ["outbound", "autoCall"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/jkB7yl4ZK3vV6Zraw32mVPMX2O6oxqw0",
          desc: this.$t('home.autoCallDesc'),
        },
        {
          productName: this.$t('home.robotCallProduct'),
          icon: Icon_RobotCall,
          open: false,
          path: ["outbound", "robotCall"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/od245kZmnOeW4pozyoZeWYbzxL6R0wMQ",
          desc: this.$t('home.robotCallDesc'),
        },
        {
          productName: this.$t('home.textRobotProduct'),
          icon: Icon_TextRobot,
          open: false,
          path: ["ai", "textrobot"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/3QD5Ea7xAo4VExxBeAjXWG1YBwgnNKb0",
          desc: this.$t('home.textRobotDesc'),
        },
        {
          productName: this.$t('home.voiceRobotProduct'),
          icon: Icon_VoiceRobot,
          open: false,
          path: ["ai", "voicerobot"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/gXMGnr6AkOP81kkBmwNzVybeZRxlzopj",
          desc: this.$t('home.voiceRobotDesc'),
        },
        {
          productName: this.$t('home.smartQualityProduct'),
          icon: Icon_Sca,
          open: false,
          path: ["qc", "sca"],
          helpUrl:
            "https://alidocs.dingtalk.com/i/p/r98zng2wa2LrAXLx/docs/pq7N1kjGYznWylK1gEm98O43vrPX95oA",
          desc: this.$t('home.smartQualityDesc'),
        },
      ],
    };
  },
  methods: {
    ...mapActions(["addTab"]),
    initApps() {
      const {
        vcc: { vccApps = undefined },
      } = this.userInfo;

      if (vccApps) {
        let products = JSON.parse(JSON.stringify(this.productList));
        products.map((item) => {
          item.open = getValByPath(vccApps, item.path);
        });

        this.productList = products;
      }
    },
    openHelpLink(item = {}) {
      const { helpUrl = "", productName = "" } = item;
      if (helpUrl) {
        window.top.open(helpUrl);
        // let tabItem = {
        //   key: productName + "-帮助文档",
        //   name: productName + "-帮助文档",
        //   url: helpUrl,
        // };
        // this.addTab(tabItem);
      } else {
        console.log("了解更多 链接无效", helpUrl);
      }
    },
    open(flag) {
      if (flag) return false;
      this.$confirm(this.$t('home.openProductTip'), this.$t('home.openProductTitle'), {
        confirmButtonText: this.$t('common.iknow'),
        showClose: false,
        showCancelButton: false,
        type: "warning",
        customClass: "diy",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.product-family {
  box-sizing: border-box;
  padding: 0 16px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: 500;
    font-size: 14px;
    line-height: 48px;
    color: #323233;
  }

  .list-wrapper {
    flex: 1 1 0;
    overflow: hidden;
    padding-bottom: 10px;

    .list {
      .item {
        position: relative;
        box-sizing: border-box;
        display: flex;
        height: 60px;
        padding: 9px;
        overflow: auto;

        .icon {
          width: 36px;
          margin-right: 8px;
          img {
            padding-top: 5px;
          }
        }

        .info {
          flex: 1;
          overflow: hidden;

          .name {
            font-size: 14px;
            color: #323233;
            line-height: 26px;

            span {
              font-size: 12px;
              color: #969799;

              &.open {
                color: #34cb82;
              }
            }
          }
          .desc {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #969799;
          }
        }

        .hover-wrapper {
          display: none;
        }

        &:hover {
          .hover-wrapper {
            display: initial;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            line-height: 60px;
            background-color: #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);

            .help-link {
              color: #0090ff;
              padding: 0 8px;
              cursor: pointer;
            }
            .open-btn {
              cursor: pointer;
              color: #fff;
              display: inline-block;
              height: 28px;
              line-height: 28px;
              width: 72px;
              text-align: center;
              background: #0090ff;
              border-radius: 2px;

              &.open {
                color: #b4b5bb;
                background: #f2f3f5;
                border: 1px solid #dcdee0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.diy {
  .el-message-box__header {
    padding: 15px 15px 10px 50px;
    .el-message-box__title {
      color: #323233;
      font-size: 14px;
    }
  }

  .el-message-box__content .el-message-box__container {
    .el-message-box__status {
      top: -160%;
      transform: rotateX(180deg);
      font-size: 22px !important;
    }

    .el-message-box__message {
      color: #646566;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/homeTab/productFamily/index.vue